import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export const RequestBodySchema = z.object({
	fileIds: z.string().array(),
});
export type RequestBody = z.infer<typeof RequestBodySchema>;

export async function callApi(input: {
	requestBody: RequestBody;
}): Promise<Optional<void>> {
	const url: string = SERVICEBASEURL.REPORT + `/v1/files/move-validated`;
	return axios.post(url, input.requestBody).toOptionalVoid();
}

